const storeTypes = {
  SET_NAME: "SET NAME",
  MARITAL_STATUS: "MARITAL STATUS",
  SET_GENDER: "SET GENDER",
  SET_DOB: "SET DOB",
  SET_PET: "SET PET",
  SET_STATE: "SET STATE",
  SET_INCAPACITY_PLAN: "INCAPACITY PLAN",
};

export default storeTypes;
